import cn from "classnames";
import { Button } from "../../../../../../button";
import { Text } from "../../../../../../text";
import { useMediaQuery } from "../../../../../../grid";
import { PAGINATION_BUTTON_ICON } from "./constants";
import { PaginationButtonProps } from "./types";
import styles from "./styles.module.scss";

export const PaginationButton = ({
  type = "default",
  disabled,
  active,
  className,
  text,
  dataTestId,
  onClick,
}: PaginationButtonProps) => {
  const icon = type === "default" ? null : PAGINATION_BUTTON_ICON[type];

  const isExtraLargeDesktop = useMediaQuery("xl");

  return (
    <Button
      htmlType="button"
      type="icon"
      disabled={disabled || active}
      className={cn(styles.button, { [styles.active]: active }, className)}
      dataTestId={dataTestId}
      onClick={onClick}
    >
      {icon ? (
        icon
      ) : (
        <Text
          weight={active ? "medium" : "regular"}
          size={isExtraLargeDesktop ? "large" : "medium"}
        >
          {text}
        </Text>
      )}
    </Button>
  );
};
